(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let updateTimeout;

    document.querySelectorAll('[data-qty-root]').forEach((root) => {
      const input = root.querySelector('input[name="quantity"]');
      const decBtn = root.querySelector('[data-qty="dec"]');
      const incBtn = root.querySelector('[data-qty="inc"]');
      const rmBtn = root.querySelector('[data-qty="remove"]');
      const lineIndex = root.dataset.line;

      if (!input || !lineIndex) return;

      const min = parseInt(input.getAttribute('min') || '0', 10);
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;

      const clamp = (n) => Math.min(Math.max(n, min), max);
      const getVal = () => parseInt(input.value || '0', 10);

      const updateCart = (newQuantity) => {
        // Fix: Allow quantity to be 0 for item removal
        // We need a special case for 0 because we want to allow removing items
        const clampedQty = newQuantity === 0 ? 0 : clamp(newQuantity);

        // Show loading state
        root.style.opacity = '0.5';
        [decBtn, incBtn, rmBtn].forEach((btn) => {
          if (btn) btn.disabled = true;
        });

        // Update cart via Shopify cart change URL
        window.location.href = `/cart/change?line=${lineIndex}&quantity=${clampedQty}`;
      };

      const setVal = (n) => {
        const v = clamp(n);
        input.value = String(v);

        // Debounce cart updates to avoid rapid API calls
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => {
          const originalQty = parseInt(input.dataset.originalQuantity, 10);
          if (v !== originalQty) {
            updateCart(v);
          }
        }, 300);
      };

      // Click handlers
      decBtn?.addEventListener('click', () => {
        const newVal = getVal() - 1;
        if (newVal >= min) {
          input.value = String(newVal);
          updateCart(newVal);
        }
      });

      incBtn?.addEventListener('click', () => {
        const newVal = getVal() + 1;
        if (newVal <= max) {
          input.value = String(newVal);
          updateCart(newVal);
        }
      });

      rmBtn?.addEventListener('click', () => {
        updateCart(0); // Remove item by setting quantity to 0
      });

      // Sanitize manual typing
      input.addEventListener('input', () => {
        const n = parseInt(input.value.replace(/\D+/g, '') || '0', 10);
        if (Number.isFinite(n)) input.value = String(n);
      });

      input.addEventListener('blur', () => setVal(getVal())); // Update cart on blur

      // Update disabled states
      const refreshDisabled = () => {
        const v = getVal();
        if (decBtn) decBtn.disabled = v <= min;
        if (incBtn) incBtn.disabled = v >= max;
      };

      root.addEventListener('click', refreshDisabled, true);
      input.addEventListener('change', refreshDisabled);
      refreshDisabled();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
